<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30"
    @click.self="closeModal"
  >
    <div class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8">
      <div class="w-[100vw] max-w-[450px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px] pt-[12px]"
          >
            <div class="w-full flex flex-col items-center">
              <MedicalKitIcon class="w-[50px] h-[50px] text-primary" />
              <span class="PC_Body1-SB !text-[#1F1D1F]"> เลือกศูนย์พักพิง </span>
            </div>

            <SelectBox2
              :searchable="true"
              :allowEmpty="true"
              label="ศูนย์พักพิง"
              :inputId="'formTeamId'"
              :keyValue="'id'"
              :keyName="'name'"
              :options="AllShelter"
              :value="form.shelter_id"
              :placeholder="'เลือกศูนย์พักพิง'"
              :warningMessage="errors.shelter_id"
              @update:modelValue="
                (res) => {
                  form.shelter_id = res;
                }
              "
            />
            <SelectBox2
              :searchable="true"
              :allowEmpty="true"
              label="ตำแหน่งหน้าที่"
              :inputId="'formTeamPosition'"
              :keyValue="'id'"
              :keyName="'name'"
              :options="AllShelterPosition"
              :value="form.position_id"
              :placeholder="'เลือกตำแหน่งหน้าที่'"
              :warningMessage="errors.position_id"
              @update:modelValue="
                (res) => {
                  form.position_id = res;
                }
              "
            />
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                :label="'บันทึก'"
                :bClass="'btn_shadow--save'"
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "../../components/Utilities/javascripts/useGlobals";
import { useShelterStore } from "@/pinia/shelter";
import { storeToRefs } from "pinia";

// const positionOption = [{ id: 2, name: "สมาชิก" }];

const { $validateMsg } = useGlobals();
const shelterStore = useShelterStore();
const { AllShelter, AllShelterPosition } = storeToRefs(shelterStore);
const input = {
  user_id: "",
  shelter_id: "",
  position_id: "",
};
const form = ref({ ...input });
const errors = ref({ ...input });
const modalIsOpened = ref(false);

const openModal = (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  console.log("data", data);
  form.value = {
    ...input,
  };
  errors.value = {
    ...input,
  };
  if (data) {
    form.value.user_id = data.id;
    // form.value.shelter_id = data.shelter_id|| "";
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const emit = defineEmits(["success"]);

const save = async () => {
  await shelterStore
    .staffJoinShelter(form.value)
    .then((response) => {
      if (response.status === 201) {
        emit("success", response.data.message);
        closeModal();
      }
    })
    .catch((error) => {
      if (error) {
        $validateMsg(error.response.data.errors, errors.value);
      }
    });
};

defineExpose({ openModal });
</script>

<style scoped></style>
